import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

// A search handed off from the global smart search input to the target grid.
// The grid consumes it once mounted and runs it through its normal filter
// pipeline (setFilterModel -> POST body). Intentionally not in the URL.
export type PendingSmartSearch = {
	route: string;
	field: string;
	value: string;
	operator: string;
};

type SmartSearchState = {
	pending: PendingSmartSearch | null;
};

const initialState: SmartSearchState = {
	pending: null,
};

const smartSearchSlice = createSlice({
	name: 'smartSearch',
	initialState,
	reducers: {
		setPendingSmartSearch(state, action: PayloadAction<PendingSmartSearch>) {
			state.pending = action.payload;
		},
		clearPendingSmartSearch(state) {
			state.pending = null;
		},
	},
});

export const { setPendingSmartSearch, clearPendingSmartSearch } =
	smartSearchSlice.actions;

export default smartSearchSlice.reducer;
